<script lang="ts">
  import { formatMoney } from '$lib/utils';
  import type { bids, lots } from '@prisma/client';
  import { writable } from 'svelte/store';

  type ILot = Pick<lots, 'base_price' | 'status'> & {
    bids: Pick<bids, 'net_amount'>[];
  };
  export let lot: ILot;
  const latest_bid = writable<bigint | number | undefined | null>(null);
  $: latest_bid.set(
    lot.bids.sort((a, b) => {
      if (a.net_amount == b.net_amount) return 0;
      else return a.net_amount > b.net_amount ? -1 : 1;
    })[0]?.net_amount
  );
</script>

{#if $latest_bid && lot.status != 'upcoming'}
  <div class={`lg:gap-x-1 lg:grid lg:grid-cols-2 lg:items-center lg:justify-end ${$$props.class}`}>
    <span class="text-base pr-2 tracking-tight text-gray-400 lg:text-xs lg:text-right">
      {#if lot.status == 'ongoing'}
        Oferta actual:{' '}
      {:else}
        Oferta ganadora:{' '}
      {/if}
    </span>
    <span class="font-extrabold tracking-tight text-primary-500 lg:text-end">
      {formatMoney($latest_bid)}
    </span>
    <span class="block lg:hidden" />
    <span class="text-base pr-2 text-gray-400 lg:text-xs lg:text-right">
      Base de venta:{' '}
    </span>
    <span class="text-base font-extrabold tracking-tight text-gray-400 lg:text-xs lg:text-end">
      {formatMoney(lot.base_price)}
    </span>
  </div>
{:else}
  <span
    class={`lg:gap-x-2 lg:grid lg:grid-cols-2 lg:items-center lg:justify-center text-base tracking-tight ${$$props.class}`}
  >
    <span class="text-base pr-2 text-gray-400 lg:pr-0 lg:text-md lg:text-right">Base de venta:</span
    >
    <span class="font-extrabold text-primary-500 tracking-tight">
      {formatMoney(lot.base_price)}
    </span>
  </span>
{/if}
